import { forwardRef } from "react";
import { faX } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import PropTypes from "prop-types";

import { Timepicker as BaseTimepicker } from "@/ui-lib/FormFields";

import styles from "./Timepicker.module.scss";

const Timepicker = forwardRef(
  (
    {
      id,
      containerClassName,
      errors,
      withoutError,
      invalid,
      setFieldValue,
      setFieldTouched,
      onChange,
      onClear,
      ...props
    },
    ref
  ) => {
    const handleChange = (e) => {
      const { value } = e;

      setFieldValue(id, value || "");
      setFieldTouched(id, true);

      onChange(id, value);
    };

    const handleClear = () => {
      if (onClear) {
        onClear();
      }

      setFieldValue(id, "");
    };

    const error = !!(errors[id] || invalid) && !withoutError;

    return (
      <div
        className={cx(
          styles.inputContainer,
          error && errors[id] && props.touched[id] ? styles.inputError : "",
          containerClassName
        )}
      >
        <BaseTimepicker ref={ref} {...props} onChange={handleChange} />
        {error && errors[id] && props.touched[id] && (
          <div className={styles.errorMessage}>{errors[id]}</div>
        )}
        {props.value && (
          <div
            className={styles.icon}
            onClick={() => {
              handleClear();
            }}
            aria-hidden="true"
          >
            <FontAwesomeIcon icon={faX} />
          </div>
        )}
      </div>
    );
  }
);

Timepicker.defaultProps = {
  setFieldTouched: () => null,
  setFieldValue: () => null,
  onChange: () => null,
  onClear: () => null,
  withoutError: false,
  invalid: false,
  errors: {},
  containerClassName: "",
  className: "",
};

Timepicker.propTypes = {
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  id: PropTypes.string.isRequired,
  withoutError: PropTypes.bool,
  invalid: PropTypes.bool,
  errors: PropTypes.shape({}),
  containerClassName: PropTypes.string,
  className: PropTypes.string,
};

export default Timepicker;
